$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  customSignup();
});

$(window).load(function () {
  customCountdown();
});

// --------------------------------
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="burger-line"></span>');
  });
}

// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// Custom Countdown update
function customCountdown() {
  setTimeout(() => {
    const $countdown = $('#siteInfoBannerWidget');
    const $countdownText = $countdown.find('#eventName');
    const countdownDays = $countdown.find('.countdownDays').text();
    $countdownText.empty().text(countdownDays);
    $countdown.css('opacity', '1');
  }, 2000);
}

function customSignup() {
  const $signupElement = $('.tier-3-container .emailSignup');
  $signupElement.find('.emailSignupText').replaceWith(`
    <div class="signup-text">
    <h3 class="signup-title">Don’t Miss Events & Deals</h3>
    <h4 class="signup-description">Join our email newsletter today!</h4>
    </div>`);

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-wrap"></div>');

  $signupElement.find('.emailInputField input').val('').attr('placeholder', 'Enter Email');
  $signupElement.find('.emailInputSubmit a').text('Sign up');
}
